"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const queIncluye = [{
  titulo: "Monitoreo continuo de automatizaciones",
  detalle: "Las cosas se rompen. Lo que importa es enterarse antes que el cliente, no después de que el cliente se queje."
}, {
  titulo: "Ajustes menores y correcciones",
  detalle: "Cambios pequeños que la operación necesita — ajustar un campo, modificar un destinatario, corregir un edge case que apareció. Sin contrato adicional."
}, {
  titulo: "SLA acordado de tiempo de respuesta",
  detalle: "Definido al iniciar según necesidad del cliente. La iguala incluye el SLA pactado, no un genérico."
}, {
  titulo: "Documentación viva actualizada",
  detalle: "Cada ajuste queda documentado. La documentación inicial no envejece — se mantiene al día con la operación real."
}];
export default function QueIncluyeSoporte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="soporte-que-incluye" id="que-incluye" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-12">
            Qué incluye.
          </h2>

          <div className="space-y-12">
            {queIncluye.map((item, i) => <ItemIncluye key={i} titulo={item.titulo} detalle={item.detalle} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}
function ItemIncluye({
  titulo,
  detalle,
  index
}: {
  titulo: string;
  detalle: string;
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} data-index={index} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
      <h3 className="font-serif text-2xl md:text-3xl text-foreground font-normal leading-tight mb-3">
        {titulo}
      </h3>
      <p className="font-sans text-base md:text-lg text-muted-foreground leading-relaxed max-w-3xl">
        {detalle}
      </p>
    </div>;
}